var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9353 7.2539L16.7466 3.06422C16.6073 2.92489 16.4419 2.81437 16.2599 2.73897C16.0779 2.66357 15.8828 2.62476 15.6858 2.62476C15.4888 2.62476 15.2937 2.66357 15.1117 2.73897C14.9297 2.81437 14.7643 2.92489 14.625 3.06422L3.06469 14.6255C2.9248 14.7642 2.81389 14.9295 2.73841 15.1115C2.66292 15.2935 2.62438 15.4887 2.62501 15.6858V19.8755C2.62501 20.2733 2.78304 20.6548 3.06435 20.9361C3.34565 21.2174 3.72718 21.3755 4.12501 21.3755H8.3147C8.51175 21.3761 8.70697 21.3375 8.88899 21.2621C9.07102 21.1866 9.23622 21.0757 9.37501 20.9358L20.9353 9.37547C21.0746 9.23617 21.1852 9.0708 21.2606 8.88879C21.336 8.70678 21.3748 8.5117 21.3748 8.31468C21.3748 8.11767 21.336 7.92259 21.2606 7.74058C21.1852 7.55857 21.0746 7.3932 20.9353 7.2539ZM8.3147 19.8755H4.12501V15.6858L12.375 7.43578L16.5647 11.6255L8.3147 19.8755ZM17.625 10.5642L13.4353 6.37547L15.6853 4.12547L19.875 8.31422L17.625 10.5642Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.074cf7c7b5a7285e757720074571e451.svg";
export { ForwardRef as ReactComponent };